import React, { Component } from "reactn";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { ModalBanner } from "../../assets";
import axios from "axios";
import { toast } from "react-toastify";
import BaseModal from "./baseModal/BaseModal";
import { CONTENT_BLOCK, STRING_INPUT, DROPDOWN, TITLE } from "./baseModal/FieldTypes";
import { BLUE_BUTTON, WHITE } from "./baseModal/colours";
import { format } from "date-fns";

class CopyExistingProgramModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      new_program_name: "",
      copyProgram: "",
      programList: [],
      canUserCreate: false,
      buttonPressed: false
    };
  }

  async componentDidMount() {
    await this.fetchInitialData();
  }

  async fetchInitialData() {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_API}/partners/programs/list`
      );
      if (resp.data.success) {
        const currentOrder = resp.data.data
          .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
          .sort((a, b) => a.display_order - b.display_order);
        this.setState({ programList: currentOrder });
      } else {
        console.error("error getting programs -----");
      }

      const result = await axios.get(`${process.env.REACT_APP_API}/partners/permissions/programs/can_user_create_program`);
      if (result.data.success) {
        this.setState({
          canUserCreate: true
        })
      }

    } catch (err) {
      console.error(err);
    }
  }

  copyExistingProgram = async () => {
    const copyFromProgram = { ...this.state.programList.find(program => parseInt(program.id) === parseInt(this.state.copyProgram)) }

    if (copyFromProgram.program_name === this.state.new_program_name) {
      toast.error("You cannot choose the same name");
      return;
    }
    this.setGlobal({loading: true});
    this.setState({ buttonPressed: true });

    let product_stripe = null;
    const copyOfPlans = [...this.global.program.plans];
    this.global.program.plans = [];
    try {
      for (const plan of copyOfPlans) {
        const parse_plan = JSON.parse(plan);

        if (parse_plan.type === "Free") {
          console.log('Free plan detected');
        } else {
          const ep = `${process.env.REACT_APP_API}/partners/stripe/add_products`;

          let plan_type = "";
          if (!parse_plan.type) {
            plan_type = "Recurring";
          } else if (parse_plan.installments) {
            plan_type = "Installments"
          } else if (parse_plan.type === "Semester") {
            plan_type = "One-Time"
          } else {
            plan_type = parse_plan.type;
          }

          const res = await axios.post(ep, {
            ...parse_plan,
            parent: "Program",
            name: this.global.program.program_name,
            type: plan_type,
            product: product_stripe
          });

          if (parse_plan.type) {
            if (parse_plan.type === "Single Session") {
              product_stripe = res.data.data.product;
              this.setGlobal(
                {
                  program: {
                    ...this.global.program,
                    product_stripe: res.data.data.product,
                    plans: [
                      ...this.global.program.plans,
                      JSON.stringify({
                        ...parse_plan,
                        id: this.global.program.plans.length,
                        prodId: res.data.data.id
                      })
                    ]
                  }
                },
              );
            } else {
              product_stripe = res.data.data.product;
              this.setGlobal(
                {
                  program: {
                    ...this.global.program,
                    product_stripe: res.data.data.product,
                    plans: [
                      ...this.global.program.plans,
                      JSON.stringify({
                        ...parse_plan,
                        id: this.global.program.plans.length,
                        prodId: res.data.data.id,
                        dropIn_stripe: res.data.data.dropIn_stripe,
                        semester_installments_plan_stripe:
                          res.data.data.semester_installments_plan_stripe
                      })
                    ]
                  }
                },
              );
            }

          } else {
            product_stripe = res.data.data.product;
            this.setGlobal(
              {
                program: {
                  ...this.global.program,
                  product_stripe: res.data.data.product,
                  plans: [
                    ...this.global.program.plans,
                    JSON.stringify({
                      ...parse_plan,
                      prodId: res.data.data,
                      id: this.global.program.plans.length
                    })
                  ]
                }
              },
            );
          }
        }
      }
      await this.dispatch.saveProgram();
    } catch (err) {
      console.error(err)
    }
    this.setGlobal({ loading: false });
    this.props.onClose();
  }

  getListChoices = () => {
    const programChoices = this.state.programList.map(program => {
      return {
        value: program.id,
        text: program.program_name
      };
    })
    return programChoices;
  };

  getBaseModalFields() {
    const fieldArr = [];

    const copyFromProgram = {
      type: DROPDOWN,
      data: {
        name: "Copy From Program",
        placeholder: "Choose here",
        value: this.state.copyProgram,
        required: true,
        choices: this.getListChoices(),
        handleChange: e => {
          this.setState({ copyProgram: e.target.value })
          const copyFromProgram = { ...this.state.programList.find(program => parseInt(program.id) === parseInt(e.target.value)) }
          copyFromProgram.id = null;
          copyFromProgram.program_name = "";
          copyFromProgram.display_order = 0;
          copyFromProgram.published = false;
          copyFromProgram.isArchived = false;

          delete copyFromProgram.timezone;
          delete copyFromProgram.createdAt;
          delete copyFromProgram.updatedAt;
          delete copyFromProgram.product_stripe;
          this.setGlobal({
            program: {
              ...copyFromProgram
            }
          });
        }
      },
      validators: { validateSubmit: () => this.state.copyProgram != "" }
    };

    const newProgramName = {
      type: STRING_INPUT,
      data: {
        name: "New Program Name",
        placeholder: "Enter new name here",
        required: true,
        value: this.state.new_program_name,
        handleChange: e => {
          this.setState({
            new_program_name: e.target.value
          })
          this.setGlobal({
            program: {
              ...this.global.program,
              program_name: e.target.value
            }
          })
        },
      },
      validators: { validateSubmit: () => this.state.new_program_name != "" }
    }

    fieldArr.push(copyFromProgram);

    if (this.state.copyProgram) {
      fieldArr.push(newProgramName);
    }

    return fieldArr;
  }

  getLimitReachedModal = () => {
    const props = {
      title: "Create program",
      fields: [
        { type: TITLE, data: { name: "You have reached your program limit." } }
      ],
      handleClose: this.props.onClose
    };
    return <BaseModal {...props} />;
  };

  getBaseModalButtons = () => {
    const copyButton = {
      name: "Copy",
      buttonColour: BLUE_BUTTON,
      textColour: WHITE,
      validatorKey: "validateSubmit",
      isDisabled: this.state.buttonPressed,
      handleClick: e => this.copyExistingProgram(e)
    };

    return [copyButton];
  };

  getBaseModalProps = () => {
    console.log("STATE", this.state, this.props);
    return {
      title: "Copy Program",
      fields: this.getBaseModalFields(),
      buttons: this.getBaseModalButtons(),
      height: "65vh",
      midSectionHeight: "49vh",
      handleClose: this.props.onClose
    };
  };

  render() {
    if (!this.state.canUserCreate) {
      return this.getLimitReachedModal()
    }

    return <BaseModal {...this.getBaseModalProps()} />;
  }
}

export default CopyExistingProgramModal;
